const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://backend.pangolino.org";

export const API_BASE_URL = rawBaseUrl.replace(/\/$/, "");

export const apiUrl = (path: string) => `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;